import React from "react"

export default props => (
    <section className={`panel panel--${props.size}`}>
        <div className="panel__inner">{props.children}</div>
    </section>
)
